module.exports = __webpack_public_path__ + "static/media/default-logo.3c5f0611.svg";